import React, { Component } from "react";
import './personalloanads.css';

class PersonalLoanforAutomobileTOP extends Component {
  render() {
    return (
      <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <a href="/home" className="a-breadcrumbs">หน้าแรก</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการของเรา</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการด้านสินเชื่อ</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">เงินกู้พิเศษเพื่อยานพาหนะ</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="/personalloanformeremployee" className="a-breadcrumbs">พนักงานไทยออยล์</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50" style={{width: '90%', fontFamily: '"Cordia New"'}}>
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>เงินกู้พิเศษเพื่อยานพาหนะ</span></h2><br/>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th style={{width: 230}}>เกณฑ์อายุงาน</th>
                      <th style={{width: 230}}>เกณฑ์ประเภทยานพาหนะ</th>
                      <th>วงเงิน</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ตั้งแต่ 1 ปี แต่ไม่ถึง 3 ปี
                      </td>
                      <td>รถยนต์ใหม่ และ/หรือใช้แล้ว<br />รถ Big Bike ใหม่หรือใช้แล้ว 
                      </td>
                      <td><b>สูงสุดไม่เกิน 500,000 บาท</b> เพื่อซื้อรถยนต์หรือรถ Big Bike (วงเงินสูงสุดนี้รวมรถ Big Bike ใหม่ สูงสุดไม่เกิน 500,000.- บาทหรือใช้แล้วสูงสุดไม่เกิน 350,000.- บาทไว้ด้วยแล้ว)
                      </td>
                    </tr>
                    <tr>
                      <td>ตั้งแต่ 3 ปี แต่ไม่ถึง 10 ปี
                      </td>
                      <td>รถยนต์ใหม่ และ/หรือใช้แล้ว<br />รถ Big Bike ใหม่หรือใช้แล้ว 
                      </td>
                      <td><b>สูงสุดไม่เกิน 1,000,000 บาท</b> เพื่อซื้อรถยนต์หรือรถ Big Bike วงเงินสูงสุดนี้ให้นับรวมรถ Big Bike ทุกสัญญาซึ่งรวมกันไม่เกิน 500,000.- บาท ไว้ด้วยแล้ว (รถ Big Bike ใหม่สูงสุดไม่เกิน 500,000.- บาท รถ Big Bike ใช้แล้วสูงสุดไม่เกิน 350,000.- บาท)
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan={2}>ตั้งแต่ 10 ปีขึ้นไป
                      </td>
                      <td>รถยนต์ใหม่<br />รถ Big Bike ใหม่หรือใช้แล้ว 
                      </td>
                      <td><b>สูงสุดไม่เกิน 1,800,000 บาท</b> เพื่อซื้อรถยนต์ใหม่และ/หรือรถ Big Bike วงเงินสูงสุดนี้ให้นับรวมรถ Big Bike ทุกสัญญารวมกันไม่เกิน 500,000.- บาท ไว้ด้วยแล้ว (Big Bike ใหม่สูงสุดไม่เกิน 500,000.- บาท Big Bike ใช้แล้วสูงสุดไม่เกิน 350,000.- บาท)
                      </td>
                    </tr>
                    <tr>
                      <td>รถยนต์ใช้แล้ว<br />รถ Big Bike ใหม่หรือใช้แล้ว
                      </td>
                      <td><b>สูงสุดไม่เกิน 1,200,000 บาท</b> เพื่อซื้อรถยนต์ใช้แล้วและ/หรือรถ Big Bike  โดยวงเงินสูงสุดนี้ได้นับรวมสัญญารถ Big Bike ทุกสัญญารวมกันไม่เกิน 500,000.- บาท ไว้ด้วยแล้ว (Big Bike ใหม่สูงสุดไม่เกิน 500,000.- บาท Big Bike ใช้แล้วสูงสุดไม่เกิน 350,000.- บาท)
                      </td>
                    </tr>
                    <tr>
                      <td>ตั้งแต่ 1 ปีขึ้นไป
                      </td>
                      <td>รถจักรยานยนต์ใหม่
                      </td>
                      <td><b>สูงสุดไม่เกิน 100,000 บาท </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th style={{width: 230}}>ประเภทยานพาหนะ</th>
                      <th style={{width: 210}}>วงเงิน</th>
                      <th colSpan={2}>งวดชำระ และหลักทรัพย์ค้ำประกัน</th>
                      <th>เอกสารที่สหกรณ์จะเก็บรักษาตลอดอายุสัญญา</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowSpan={3}>รถยนต์ใหม่
                      </td>
                      <td rowSpan={3}>• 80% ของราคาซื้อขาย<br /> • ตามเกณฑ์อายุงาน<br /> • ไม่เกิน 1,800,000 บาท
                      </td>
                      <td style={{width: 180}}>ไม่เกิน 60 งวด
                      </td>
                      <td style={{width: 180}}>ไม่ต้องค้ำประกัน
                      </td>
                      <td rowSpan={6}>
                         สมุดคู่มือทะเบียนรถยนต์<br />
                         กรมธรรม์ประกันภัยประเภท 1 และ พรบ. <br />
                         เอกสารชุดการโอนกรรมสิทธิ์รถยนต์ (เอกสารมอบอำนาจ และแบบคำขอโอนและรับโอนของกรมการขนส่งทางบก) 
                      </td>
                    </tr>
                    <tr>
                      <td>ตั้งแต่ 61-84 งวด
                      </td>
                      <td>หุ้น และ/หรือเงินฝาก 5% ของวงเงินกู้
                      </td>
                    </tr>
                    <tr>
                      <td>ตั้งแต่ 85-120 งวด
                      </td>
                      <td>หุ้น และ/หรือเงินฝาก 10% ของวงเงินกู้
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan={3}>รถยนต์ใช้แล้ว
                      </td>
                      <td rowSpan={3}>• 80% ของราคาซื้อขาย  หรือ  ราคาประเมิน  อย่างใดอย่างหนึ่งที่มีมูลค่าต่ำกว่า  และอายุรถต้องไม่เกิน 7 ปี ในวันยื่นคำขอกู้<br /> • ตามเกณฑ์อายุงาน<br /> • ไม่เกิน 1,200,000 บาท
                      </td>
                      <td style={{width: 180}}>ไม่เกิน 60 งวด
                      </td>
                      <td style={{width: 180}}>ไม่ต้องค้ำประกัน
                      </td>
                    </tr>
                    <tr>
                      <td>ตั้งแต่ 61-84 งวด
                      </td>
                      <td>หุ้น และ/หรือเงินฝาก 5% ของวงเงินกู้
                      </td>
                    </tr>
                    <tr>
                      <td>ตั้งแต่ 61-108 งวด
                      </td>
                      <td>หุ้น และ/หรือเงินฝาก 10% ของวงเงินกู้
                      </td>
                    </tr>
                    <tr>
                      <td>รถ Big Bike ใหม่(250 CC ขึ้นไป)
                      </td>
                      <td>• 80% ของราคาซื้อขาย <br /> • ไม่เกิน 500,000.- บาท
                      </td>
                      <td style={{width: 180}}>ไม่เกิน 60 งวด
                      </td>
                      <td style={{width: 180}}>ไม่ต้องค้ำประกัน
                      </td>
                      <td rowSpan={2}>
                         สมุดคู่มือทะเบียนรถยนต์<br />
                         กรมธรรม์ประกันภัยประเภท 1 และ พรบ. <br />
                         เอกสารชุดการโอนกรรมสิทธิ์รถยนต์ (เอกสารมอบอำนาจ และแบบคำขอโอนและรับโอนของกรมการขนส่งทางบก) 
                      </td>
                    </tr>
                    <tr>
                      <td>รถ Big Bike ใช้แล้ว(250 CC ขึ้นไป)
                      </td>
                      <td>• 80% ของราคาซื้อขาย  หรือ  ราคาประเมิน  อย่างใดอย่างหนึ่งที่มีมูลค่าต่ำกว่า  และอายุรถต้องไม่เกิน 4 ปี ในวันยื่นคำขอกู้<br /> • ไม่เกิน 350,000.- บาท
                      </td>
                      <td style={{width: 180}}>ไม่เกิน 48 งวด
                      </td>
                      <td style={{width: 180}}>ไม่ต้องค้ำประกัน
                      </td>
                    </tr>
                    <tr>
                      <td>รถจักรยานยนต์ใหม่
                      </td>
                      <td>• 80% ของราคาซื้อขาย <br /> • ไม่เกิน 100,000.- บาท
                      </td>
                      <td>ไม่เกิน 60 งวด
                      </td>
                      <td>ไม่ต้องค้ำประกัน
                      </td>
                      <td> สมุดคู่มือทะเบียนรถยนต์<br />
                         พ.ร.บ. <br />
                         เอกสารชุดการโอนกรรมสิทธิ์รถยนต์ (เอกสารมอบอำนาจ และแบบคำขอโอนและรับโอนของกรมการขนส่งทางบก) </td>
                    </tr>
                  </tbody>
                </table>
                <p style={{fontSize:'20px'}}><b>การนับรวมวงเงินกรณีมีมากกว่า 1 สัญญา</b></p>
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th>ประเภทยานพาหนะ</th>
                      <th>วงเงิน สิทธิ</th>
                      <th>งวดชำระและหลักทรัพย์ค้ำประกัน</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>รถยนต์ใหม่ + รถยนต์ใหม่
                      </td>
                      <td rowSpan={4}>วงเงินแต่ละสัญญาไม่เกินวงเงินสูงสุดที่กำหนด
                      </td>
                      <td rowSpan={4}>ทุกสัญญารวมกันไม่เกินวงเงิน 1,800,000 บาท
                      </td>
                    </tr>
                    <tr>
                      <td>รถยนต์ใหม่ + รถยนต์ใช้แล้ว
                      </td>
                    </tr>
                    <tr>
                      <td>รถยนต์ใหม่ + รถยนต์ใหม่ + รถ Big Bike
                      </td>
                    </tr>
                    <tr>
                      <td>รถยนต์ใหม่ + รถยนต์ใช้แล้ว + รถ Big Bike
                      </td>
                    </tr>
                    <tr>
                      <td>รถยนต์ใช้แล้ว + รถยนต์ใช้แล้ว 
                      </td>
                      <td rowSpan={2}>วงเงินแต่ละสัญญาไม่เกินวงเงินสูงสุดที่กำหนด
                      </td>
                      <td rowSpan={2}>ทุกสัญญารวมกันไม่เกินวงเงิน 1,200,000 บาท
                      </td>
                    </tr>
                    <tr>
                      <td>รถยนต์ใช้แล้ว + รถยนต์ใช้แล้ว + รถ Big Bike
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p  style={{fontSize:'20px'}}><b>รายละเอียดเงื่อนไข และเอกสารที่เกี่ยวกับการกู้พิเศษเพื่อยานพาหนะ</b></p>
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <tbody>
                    <tr>
                      <td style={{width: 170}}>เงื่อนไข
                      </td>
                      <td>
                        <ul className="mb-25">
                          <li>1. ผู้กู้ต้องมีอายุงานตั้งแต่ 1 ปีขึ้นไป</li>
                          <li>2. วัตถุประสงค์ของการกู้ เพื่อการซื้อรถยนต์ รถ Big Bike และรถจักรยานยนต์ ในชื่อของสมาชิกเท่านั้น (ผู้กู้ต้องไม่มีชื่อผู้ถือกรรมสิทธิ์ในรถยนต์ รถ Big Bike  คันดังกล่าว ก่อนการยื่นกู้และไม่ได้กู้เพื่อซื้อรถยนต์จากบิดา มารดา หรือบิดา มารดาคู่สมรส หรือคู่สมรส) </li>
                          <li>3. จำนวนเงินที่ผ่อนชำระเงินคืนเงินกู้ประเภทดังกล่าว ให้นำมาคิดรวมกับการคำนวณ 50% Take Home</li>
                          <li>4. ผู้กู้จะกู้เงินพิเศษเพื่อยานพาหนะ (รถยนต์ และรถ Big Bike) ได้มากกว่า 1 รายการ แต่เมื่อนับหนี้คงเหลือรวมกับวงเงินที่กู้ใหม่ ต้องไม่เกินวงเงินสูงสุดของประเภทใดประเภทหนึ่ง </li>
                          <li>5. การกู้เงินเพื่อซื้อรถจักรยานยนต์ใหม่ ผู้กู้สามารถกู้ได้มากกว่า 1 คัน แต่เมื่อนับหนี้คงเหลือรวมกับวงเงินที่กู้ใหม่ต้องไม่เกิน 100,000.-บาท (ไม่ใช้วงเงินร่วมกับรถยนต์ และรถ Big Bike)</li>
                          <li>6. งวดผ่อนชำระสำหรับรถยนต์ใช้แล้ว สูงสุดไม่เกิน 108 งวด และเมื่อรวมอายุรถกับงวดผ่อนชำระต้องไม่เกิน 144 งวด</li>
                          <li>7. งวดผ่อนชำระสำหรับรถ Big Bike ใช้แล้ว สูงสุดไม่เกิน 48 งวด และเมื่อรวมอายุรถกับงวดผ่อนชำระต้องไม่เกิน 60 งวด</li>
                          <li>8. ผู้กู้สามารถเลือกงวดผ่อนชำระ เกิน 60 งวดได้ แต่ต้องมีหลักทรัพย์ค้ำประกันตามตารางข้างต้น ซึ่งผู้กู้สามารถลดหลักประกันได้ตามเงื่อนไขที่กำหนด</li>
                          <li>9. ราคารถยนต์ใหม่ ให้รวมอุปกรณ์เพิ่มเติม (ถ้ามี) ได้ไม่เกิน 25% ของราคาซื้อขาย และไม่เกินวงเงินสูงสุด</li>
                          <li>10. ผู้กู้ต้องทำประกันภัยประเภท 1 ระบุชื่อ สหกรณ์ออมทรัพย์ไทยออยล์ จำกัด เป็นผู้รับผลประโยชน์ <b><u>ในปีแรก</u></b> ผู้กู้สามารถเลือกทำประกันภัยได้ ดังนี้
                            <ul className="mb-25">
                              <li><b><u>เลือกทำประกันภัยผ่านสหกรณ์</u></b></li>
                              <li>สหกรณ์จะหักค่าเบี้ยประกันภัยจากวงเงินกู้ที่อนุมัติ</li>
                              <li><b><u>เลือกทำประกันภัยผ่านบริษัทอื่นๆ ด้วยตนเอง</u></b></li>
                              <li>ทำประกันอุบัติเหตุกลุ่มเพิ่มเติม โดยทุนประกัน จะเท่ากับวงเงินกู้ และระยะเวลาคุ้มครองเท่ากับระยะเวลาการผ่อนชำระตามสัญญา </li>
                              <li>ส่งเอกสารกรมธรรม์ให้สหกรณ์ภายใน 30 วัน นับจากวันที่รับเงินกู้</li>
                              <li><b><u>การต่ออายุในปีถัดไป</u></b></li>
                              <li>ผู้กู้สามารถเปลี่ยนแปลงแนวทางการทำประกันภัยได้  โดยผู้กู้จะเปลี่ยนแปลงได้เพียง 1 ครั้ง  ตลอดสัญญาการกู้</li>
                              <li>ส่งกรมธรรม์ก่อนครบกำหนด 10 วันทำการ</li>
                            </ul>
                          </li>
                          <li>11.	ผู้กู้ขอเปลี่ยนแปลงสภาพเดิมของรถยนต์  ต้องแจ้งต่อสหกรณ์ฯ ก่อนการเสียภาษีรถยนต์ประจำปีในปีถัดไป (ต่อทะเบียน)</li>
                          <li>12.	ผู้กู้ต้องยินยอมให้สหกรณ์ดำเนินการเสียภาษีรถยนต์ประจำปี (ต่อทะเบียน) พร้อมทั้งให้ความร่วมมือในการตรวจสภาพรถยนต์  และนำใบตรวจสภาพมายื่นต่อสหกรณ์ก่อนการเสียภาษีรถยนต์ประจำปี (ต่อทะเบียน) โดยสหกรณ์จะสำรองเงินไปก่อน และเรียกเก็บจากสมาชิกในภายหลัง โดยมีค่าธรรมเนียมรายการละ 100 บาท</li>
                          <li>13.	กรณีผู้กู้ต้องการชำระหนี้เงินกู้พิเศษเพื่อยานพาหนะ ผู้กู้จะต้องผ่อนชำระต่อสหกรณ์แล้วอย่างน้อย 6 งวด จึงจะชำระหนี้ทั้งจำนวนได้ หากชำระก่อนเวลาที่กำหนด สหกรณ์จะถือว่าผู้กู้ใช้เงินกู้ผิดวัตถุประสงค์ ผู้กู้จะต้องชำระคืนเงินกู้ทั้งจำนวนพร้อมค่าปรับตามที่สหกรณ์กำหนด</li>
                          <li>14.	ผู้กู้จะไม่สามารถขอยกเลิกการทำประกันอุบัติเหตุกลุ่มในทุกกรณี </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>ขั้นตอนการกู้
                      </td>
                      <td>
                        <ul className="mb-25">
                          <li>ยื่นคำขอกู้ผ่านทาง ระบบข้อมูลสมาชิกออนไลน์</li>
                          <li><b><u>รอบการกู้มี 2 รอบ ยื่นกู้</u></b></li>
                          <li>ภายในวันที่ 1 ของแต่ละเดือน รอบการรับเงิน วันที่ 16 </li>
                          <li>ภายในวันที่ 15 ของแต่ละเดือน รอบการรับเงิน วันที่ 1 ของเดือนถัดไป </li><br />
                          <li>คณะกรรมการเงินกู้ จะพิจารณาอนุมัติเงินกู้เมื่อเอกสารครบถ้วน</li>
                          <li>เมื่อคณะกรรมการเงินกู้ พิจารณาอนุมัติเงินกู้แล้วนั้น  สมาชิกจะได้รับ E-mail อนุมัติเงินกู้ </li>
                          <li>สมาชิกต้องมาลงนามที่ห้องสหกรณ์ภายในกำหนด พร้อมเงินฝากค้ำประกัน (ถ้ามี) </li>
                          <li>เมื่อสมาชิกลงนามสัญญาเรียบร้อยแล้วจะได้รับเงินกู้ในวันตามรอบที่ยื่นกู้  (กรณีวันที่ 1 และ 16 เป็นวันหยุดทำการ สหกรณ์จะจ่ายเงินในวันเปิดทำการถัดไป) </li>
                          <li>ผู้กู้สามารถกำหนดวันรับเงินกู้ภายหลังจากวันที่สหกรณ์กำหนดได้ เมื่อผู้กู้และผู้ขายพร้อม ทั้งนี้ต้องไม่เกิน 90 วัน หลังจากวันที่คณะกรรมการเงินกู้ พิจารณาอนุมัติเงินกู้ </li>
                          <li>กรณีที่ผู้กู้ได้รับอนุมัติเงินกู้แล้ว ผู้กู้ต้องนำเงินกู้ไปซื้อรถตามที่ระบุในใบจองหรือตามสัญญาซื้อขายเท่านั้น หากมีการเปลี่ยนแปลงเงื่อนไขหรือรายละเอียดรถในการซื้อขาย ให้แจ้งต่อสหกรณ์เพื่อนำเสนอต่อคณะกรรมการเงินกู้พิจารณาเงินกู้เพื่ออนุมัติ หรือเพื่อทราบเป็นกรณีไป </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>เอกสารประกอบการยื่นกู้
                      </td>
                      <td>
                        <ul className="mb-25">
                          <li>สำเนาใบขับขี่ตามประเภทยานพาหนะ</li>
                          <li>สำเนาบัตรประจำตัวประชาชน</li>
                          <li>สำเนาทะเบียนบ้าน</li>
                          <li>สำเนาทะเบียนสมรส (กรณีชำระหนี้เงินกู้เพื่อซื้อรถยนต์ของคู่สมรส)</li>
                          <li><b><u>รถยนต์และรถ Big Bike ใหม่</u></b></li>
                          <li>ใบจองรถ หรือใบเสนอราคา พร้อมรายละเอียดส่วนลดและรายการแถม</li>
                          <li><b><u>รถยนต์และรถ Big Bike ใช้แล้ว</u></b></li>
                          <li>สัญญาซื้อขาย</li>
                          <li>สำเนาเอกสารการโอนเงินของผู้ถือกรรมสิทธิ์ (ฉบับของกรมการขนส่ง) กรณีผู้ถือกรรมสิทธิ์ไม่ได้เป็นผู้ขายในสัญญาซื้อขาย</li>
                          <li>สำเนากรมธรรม์ประกันภัยประเภท 1 และพรบ. (กรณีใช้ประกันภัยต่อเนื่องจากผู้ถือกรรมสิทธิ์เดิม หรือผู้ขาย)</li>
                          <li>สำเนาสมุดทะเบียนรถยนต์ทุกหน้า ที่มีรายการผู้ถือกรรมสิทธิ์ และผู้ครอบครอง</li>
                          <li><b><u>ไถ่ถอนรถยนต์จากสถาบันการเงิน</u></b></li>
                          <li>เอกสารระบุยอดหนี้คงเหลือจากสถาบันการเงิน</li>
                          <li>สำเนากรมธรรม์ประกันภัยประเภท 1 และพรบ. (กรณีใช้ประกันภัยต่อเนื่องจากผู้ถือกรรมสิทธิ์เดิม หรือผู้ขาย)</li>
                          <li>สำเนาสมุดทะเบียนรถยนต์ทุกหน้า ที่มีรายการผู้ถือกรรมสิทธิ์ และผู้ครอบครอง</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>เอกสารที่ต้องส่งภายหลังจากการรับเงินกู้
                      </td>
                      <td>
                        <ul className="mb-25">
                          <li>ใบเสร็จรับเงินที่มียอดการจ่ายตรงกับจำนวนเงินที่ระบุในใบเสนอราคาหรือใบจองรถ ภายใน 15 วันหลังจากวันที่รับเงินกู้</li>
                          <li><b>สมุดทะเบียนรถ</b></li>
                          <li>ภายใน 60 วันหลังจากวันที่รับเงินกู้ (สำหรับรถใหม่) </li>
                          <li>ภายใน 15 วันหลังจากวันที่รับเงินกู้ (สำหรับรถใช้แล้ว)</li>
                          <li><b>กรมธรรม์ประกันภัยประเภท 1 ที่มาพร้อมกับการซื้อขาย ระบุชื่อ สหกรณ์ออมทรัพย์ไทยออยล์ จำกัด เป็นผู้รับผลประโยชน์</b></li>
                          <li>ภายใน 30 วันหลังจากวันที่รับเงินกู้ (สำหรับรถใหม่) </li>
                          <li>ภายใน 15 วันหลังจากวันที่รับเงินกู้ (สำหรับรถใช้แล้ว)</li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default PersonalLoanforAutomobileTOP;
